import { useSelector } from 'react-redux';
import { hasAccessToEditProfileSelector } from '../../../CommonSelectors/CommonAreaSelector';

export const useGoalFormDisabled = () => {
  const canEdit = useSelector(hasAccessToEditProfileSelector);

  return !canEdit;
};
